import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
    name: 'customdate',
    standalone: false
})
export class CustomDatePipe implements PipeTransform {
  transform(value: string, format: string, type: string, parseMask: string = null): string {
    // Convert moment format strings to Luxon format
    const luxonInputFormat = parseMask ? this.convertMomentToLuxonFormat(parseMask) : undefined;
    const luxonOutputFormat = this.convertMomentToLuxonFormat(format);
    
    // Parse the date
    let dt: DateTime;
    if (luxonInputFormat) {
      dt = DateTime.fromFormat(value, luxonInputFormat);
    } else {
      // Try ISO format first, then SQL format, then legacy formats
      dt = DateTime.fromISO(value);
      if (!dt.isValid) {
        dt = DateTime.fromSQL(value);
      }
      if (!dt.isValid) {
        dt = DateTime.fromFormat(value, 'yyyy-MM-dd');
      }
      if (!dt.isValid) {
        dt = DateTime.fromFormat(value, 'MM/dd/yyyy');
      }
    }
    
    // Handle invalid dates
    if (!dt.isValid) {
      return 'Invalid date';
    }
    
    // Convert to UTC if needed
    if (type === 'utc') {
      dt = dt.toUTC();
    }
    
    // Handle empty format
    if (!format) {
      return dt.toISO();
    }
    
    return dt.toFormat(luxonOutputFormat);
  }
  
  private convertMomentToLuxonFormat(momentFormat: string): string {
    // Map moment format tokens to Luxon equivalents
    return momentFormat
      // Year
      .replace(/YYYY/g, 'yyyy')
      .replace(/YY/g, 'yy')
      // Quarter
      .replace(/Q/g, 'q')
      // Month
      .replace(/MMMM/g, 'LLLL')
      .replace(/MMM/g, 'LLL')
      .replace(/MM/g, 'MM')
      .replace(/M/g, 'M')
      // Day
      .replace(/DD/g, 'dd')
      .replace(/D/g, 'd')
      // Day of week
      .replace(/dddd/g, 'cccc')
      .replace(/ddd/g, 'ccc')
      // Hour
      .replace(/HH/g, 'HH')
      .replace(/H/g, 'H')
      .replace(/hh/g, 'hh')
      .replace(/h/g, 'h')
      // Minute
      .replace(/mm/g, 'mm')
      .replace(/m/g, 'm')
      // Second
      .replace(/ss/g, 'ss')
      .replace(/s/g, 's')
      // AM/PM
      .replace(/A/g, 'a')
      .replace(/a/g, 'a');
  }
}
